import { addValidationRule } from '@akihirotakamura/formsy-react'

addValidationRule('isTime', (values, value) => {
  if (!value || value === '') return true
  return value.replace(/\u003a/g, '').match(/[0-9]{2}[0-5][0-9]/)
})
